<app-listing-layout [showFilterPanel]="false">
  <div content>
    <div *ngIf="isLoading" class="account-skeleton-shell">
      <div class="skeleton-page-header">
        <div class="content-header-copy">
          <ejs-skeleton shape="Text" width="80px" height="11px"></ejs-skeleton>
          <ejs-skeleton shape="Text" width="440px" height="14px"></ejs-skeleton>
          <ejs-skeleton shape="Text" width="320px" height="14px"></ejs-skeleton>
        </div>
        <div class="header-highlight">
          <ejs-skeleton shape="Text" width="130px" height="11px"></ejs-skeleton>
          <ejs-skeleton shape="Text" width="100px" height="16px"></ejs-skeleton>
        </div>
      </div>

      <div class="account-skeleton-grid">
        <div class="account-main-column">
          <div class="account-skeleton-card">
            <ejs-skeleton shape="Text" width="72px" height="11px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="230px" height="18px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="380px" height="13px"></ejs-skeleton>
            <div class="skeleton-field-grid">
              <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
              <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
              <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
              <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
              <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
              <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
            </div>
            <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
          </div>

          <div class="account-skeleton-card">
            <ejs-skeleton shape="Text" width="60px" height="11px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="160px" height="18px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="340px" height="13px"></ejs-skeleton>
            <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
            <div class="skeleton-field-grid">
              <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
              <ejs-skeleton shape="Rectangle" width="100%" height="46px"></ejs-skeleton>
            </div>
          </div>
        </div>

        <div class="account-side-column">
          <div class="account-skeleton-card">
            <ejs-skeleton shape="Text" width="66px" height="11px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="140px" height="18px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="260px" height="13px"></ejs-skeleton>
            <div class="skeleton-log-list">
              <div class="skeleton-log-item" *ngFor="let i of [1,2,3,4]">
                <ejs-skeleton shape="Text" width="150px" height="14px"></ejs-skeleton>
                <ejs-skeleton shape="Text" width="90px" height="12px"></ejs-skeleton>
              </div>
            </div>
          </div>

          <div class="account-skeleton-card">
            <ejs-skeleton shape="Text" width="82px" height="11px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="200px" height="18px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="240px" height="13px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="100%" height="13px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="92%" height="13px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="80%" height="13px"></ejs-skeleton>
            <ejs-skeleton shape="Text" width="88%" height="13px"></ejs-skeleton>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoading && profile as data" class="account-shell">
      <div class="content-header">
        <div class="content-header-copy">
          <span class="content-kicker">Minha conta</span>
          <p class="content-description">
            Atualize o seu e-mail de contato ou recuperação de senha, defina uma nova senha quando necessário e consulte os dados básicos vinculados ao seu cadastro.
          </p>
        </div>

        <div class="header-highlight">
          <span class="header-highlight-label">Última alteração de senha</span>
          <strong>{{ lastPasswordChangeLabel }}</strong>
        </div>
      </div>

      <form [formGroup]="form" class="account-form" (ngSubmit)="onSave()">
        <div class="account-form-grid">
          <div class="account-main-column">
            <app-panel
              class="form-panel"
              [title]="'Informações do participante'"
              [subtitle]="'Esses dados são exibidos para conferência e identificam a conta que está acessando o sistema.'"
              [sectionTag]="'Dados básicos'">
              <div formGroupName="basicInfo" class="form-section-grid form-section-grid--two">
                <div class="form-field form-field--full">
                  <app-form-field-label [text]="'Nome completo'" [forId]="'name'"></app-form-field-label>
                  <ejs-textbox id="name" formControlName="name" [readonly]="true"></ejs-textbox>
                </div>

                <div class="form-field">
                  <app-form-field-label [text]="'Data de nascimento'" [forId]="'birthDate'"></app-form-field-label>
                  <ejs-textbox id="birthDate" formControlName="birthDate" [readonly]="true"></ejs-textbox>
                </div>

                <div class="form-field">
                  <app-form-field-label [text]="'Matrícula'" [forId]="'employeeCode'"></app-form-field-label>
                  <ejs-textbox id="employeeCode" formControlName="employeeCode" [readonly]="true"></ejs-textbox>
                </div>

                <div class="form-field">
                  <app-form-field-label [text]="'Cidade'" [forId]="'city'"></app-form-field-label>
                  <ejs-textbox id="city" formControlName="city" [readonly]="true"></ejs-textbox>
                </div>

                <div class="form-field">
                  <app-form-field-label [text]="'UF'" [forId]="'state'"></app-form-field-label>
                  <ejs-textbox id="state" formControlName="state" [readonly]="true"></ejs-textbox>
                </div>

                <div class="form-field">
                  <app-form-field-label [text]="'Setor'" [forId]="'department'"></app-form-field-label>
                  <ejs-textbox id="department" formControlName="department" [readonly]="true"></ejs-textbox>
                </div>

                <div class="form-field">
                  <app-form-field-label [text]="'Cargo'" [forId]="'role'"></app-form-field-label>
                  <ejs-textbox id="role" formControlName="role" [readonly]="true"></ejs-textbox>
                </div>
              </div>
            </app-panel>

            <app-panel
              class="form-panel panel-fill-height"
              [title]="'E-mail e senha'"
              [subtitle]="'Escolha quais dados deseja atualizar e preencha apenas os campos necessários para concluir a alteração.'"
              [sectionTag]="'Acesso'">
              <div *ngIf="saveMessage" class="feedback-banner feedback-banner--success">
                {{ saveMessage }}
              </div>

              <div *ngIf="errorMessage" class="feedback-banner feedback-banner--error">
                {{ errorMessage }}
              </div>

              <div formGroupName="access" class="form-section-grid">
                <div class="editable-group editable-group--email">
                  <div class="edit-toggle-row">
                    <ejs-checkbox formControlName="enableEmailEdit" label="Editar e-mail de contato"></ejs-checkbox>
                  </div>

                  <div class="form-field form-field--full">
                  <app-form-field-label
                    [text]="'E-mail de contato ou recuperação'"
                    [forId]="'email'"
                    [required]="isEmailEditEnabled"></app-form-field-label>
                  <ejs-textbox id="email" formControlName="email" type="email"></ejs-textbox>
                  <div class="field-support">
                    <small class="field-hint">Esse e-mail será usado para contato e para recuperação de senha quando necessário.</small>
                    <app-form-control-error [control]="emailControl" [messages]="emailErrorMessages"></app-form-control-error>
                  </div>
                </div>
              </div>
              </div>

              <div formGroupName="security" class="form-section-grid form-section-grid--two">
                <div class="editable-group editable-group--security form-field--full">
                  <div class="edit-toggle-row">
                    <ejs-checkbox formControlName="enablePasswordEdit" label="Editar senha de acesso"></ejs-checkbox>
                  </div>

                  <div class="form-field form-field--security-note">
                    <div class="security-note">
                      <strong>{{ isCredentialRegistrationRequired ? 'Cadastro pendente' : 'Orientação rápida' }}</strong>
                      <span>
                        {{ isCredentialRegistrationRequired
                          ? 'Para concluir o cadastro, informe o e-mail de contato ou recuperação e defina a senha de acesso nesta etapa.'
                          : 'Use uma senha com no mínimo 8 caracteres e evite repetir combinações já usadas em outros sistemas.' }}
                      </span>
                    </div>
                  </div>

                  <div class="security-fields-grid" *ngIf="shouldShowPasswordFields">
                    <div class="form-field form-field--full" *ngIf="hasPasswordConfigured">
                      <app-form-field-label
                        [text]="'Senha atual'"
                        [forId]="'currentPassword'"
                        [required]="shouldRequireCurrentPassword"></app-form-field-label>
                      <ejs-textbox id="currentPassword" formControlName="currentPassword" type="password"></ejs-textbox>
                        <app-form-control-error
                          [control]="currentPasswordControl"
                          [messages]="currentPasswordErrorMessages"></app-form-control-error>
                    </div>

                    <div class="form-field">
                      <app-form-field-label
                        [text]="'Nova senha'"
                        [forId]="'newPassword'"
                        [required]="isPasswordEditEnabled"></app-form-field-label>
                      <ejs-textbox id="newPassword" formControlName="newPassword" type="password"></ejs-textbox>
                        <app-form-control-error
                          [control]="newPasswordControl"
                          [messages]="newPasswordErrorMessages"></app-form-control-error>
                    </div>

                    <div class="form-field">
                      <app-form-field-label
                        [text]="'Confirmar nova senha'"
                        [forId]="'confirmNewPassword'"
                        [required]="isPasswordEditEnabled"></app-form-field-label>
                      <ejs-textbox id="confirmNewPassword" formControlName="confirmNewPassword" type="password"></ejs-textbox>
                        <app-form-control-error
                          [control]="confirmNewPasswordControl"
                          [messages]="confirmPasswordErrorMessages"></app-form-control-error>
                    </div>
                  </div>
                </div>
              </div>
            </app-panel>
          </div>

          <aside class="account-side-column">
            <app-panel
              class="side-panel"
              [title]="'Logs da conta'"
              [subtitle]="'Acompanhe as operações mais recentes realizadas no seu cadastro e no seu acesso ao sistema.'"
              [sectionTag]="'Histórico'">
              <ul class="activity-log-list">
                <li *ngFor="let log of activityLogs">
                  <div class="activity-log-row">
                    <strong>{{ log.operation }}</strong>
                    <span class="activity-log-date">{{ log.occurredAt | date:'dd/MM/yyyy HH:mm' }}</span>
                  </div>
                  <span class="activity-log-user">{{ log.actorName }}</span>
                </li>
              </ul>
            </app-panel>

            <app-panel
              class="side-panel side-panel--accent panel-fill-height"
              [title]="'Boas práticas recomendadas'"
              [subtitle]="'Alguns cuidados simples ajudam a manter sua conta protegida e seus dados sempre corretos.'"
              >
              <ul class="guideline-list">
                <li>Revise o e-mail cadastrado sempre que houver mudança de contato.</li>
                <li>Defina uma senha forte e evite reutilizar combinações já usadas em outros sistemas.</li>
                <li>Evite anotar a senha em locais visíveis no ambiente de trabalho.</li>
              </ul>
            </app-panel>
          </aside>
        </div>

        <div class="form-actions">
          <button ejs-button type="button" cssClass="e-outline" (click)="onCancel()" [disabled]="isSaving">
            Cancelar alterações
          </button>

          <button ejs-button type="submit" cssClass="e-primary" [disabled]="isSaving">
            {{ isSaving ? 'Salvando...' : 'Salvar alterações' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</app-listing-layout>
